import map from 'lodash/map'
import get from 'lodash/get'
import omitBy from 'lodash/omitBy'
import assign from 'lodash/assign'
import parseInt from 'lodash/parseInt'
import cloneDeep from 'lodash/cloneDeep'
import isUndefined from 'lodash/isUndefined'
import { get as apiGet, post as apiPost, TYPE_BROOKLYN_JSON } from '../../api-client/index'

export const REFERRAL_ITEMS_PER_PAGE = 25
export const REFERRAL_TRANSACTION_TYPE_SIGNUP = 'SIGNUP'
export const REFERRAL_TRANSACTION_TYPE_PLAN_CHANGE = 'PLAN CHANGE'
export const REFERRAL_TRANSACTION_TYPE_REACTIVATION = 'REACTIVATION'

const REFERRAL_DATA_SCHEMA = {
  referralId: null,
  success: null,
  referrals: {
    count: 0,
    referredUsers: [],
  },
}

const REFERRAL_ATTRIBUTION_DATA_SCHEMA = {
  success: null,
  id: 0,
}

export const REFERRAL_TYPE = {
  PORTAL: 'portal',
  UNKNOWN: 'referral',
  REFERRAL: 'referral',
  SHARE: 'share',
}

export function transform (user) {
  return {
    image: get(user, ['profile', 'picture', 'hdtv_190x266'], ''),
    url: get(user, 'url') ? `/portal/${get(user, 'url')}` : null,
    subscribers: get(user, 'subscriberCount', 0),
    createdAt: get(user, 'createdAt', ''),
    tagline: get(user, 'tagline', ''),
    title: get(user, 'username', ''),
    firstName: get(user, 'first_name', ''),
    source: get(user, 'source', ''),
    tags: get(user, 'tags', []),
    id: get(user, 'uuid'),
  }
}

export async function getReferralData (options) {
  try {
    const {
      auth, p, pp, createdAt, referralType,
    } = options
    const res = await apiGet('v1/user/referrals', {
      p, pp, createdAt, referralType,
    }, { auth }, TYPE_BROOKLYN_JSON)
    return handleGetReferralDataResponse(res)
  } catch (e) {
    return handleGetReferralDataResponse({}, true)
  }
}

export async function postUserReferralAttributionData (options) {
  try {
    const {
      auth,
      referralId,
      source = 'UNKNOWN',
      sourceId,
      transactionId,
      triggerEvent,
      planContentSetId,
      planName,
    } = options
    const id = typeof sourceId === 'number' ? sourceId : undefined
    const body = omitBy({
      referralId,
      sourceId: id,
      source,
      transactionId,
      triggerEvent,
      planContentSetId,
      planName,
    }, isUndefined)
    const res = await apiPost('v1/user/referrals', body, { auth }, TYPE_BROOKLYN_JSON)
    return handlePostUserReferralAttributionDataResponse(res)
  } catch (e) {
    return handlePostUserReferralAttributionDataResponse({}, true)
  }
}

export function handleGetReferralDataResponse (res) {
  const data = get(res, 'body', {})
  const referredUsers = get(data, 'referrals.referredUsers', [])
  return assign(cloneDeep(REFERRAL_DATA_SCHEMA), {
    referralId: get(data, 'referralId', null),
    referrals: {
      count: parseInt(get(data, 'referrals.count', 0)),
      referredUsers: map(referredUsers, (user) => transform(user)),
    },
    success: get(data, 'success'),
  })
}

export function handlePostUserReferralAttributionDataResponse (res) {
  const data = get(res, 'body', {})
  return assign(cloneDeep(REFERRAL_ATTRIBUTION_DATA_SCHEMA), {
    success: get(data, 'success'),
    id: get(data, 'id', null),
  })
}
